import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function Star({ height = 60, width = 60, ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path clipRule="evenodd" d="m12 5.04804-1.8408 3.51111c-.37197.70954-1.09104 1.20134-1.92284 1.31512l-4.11611.56303 2.97844 2.733c.6019.5523.87656 1.3481.73447 2.1279l-.70311 3.8591 3.68155-1.822c.744-.3682 1.6328-.3682 2.3768 0l3.6816 1.822-.7032-3.8591c-.1421-.7798.1326-1.5756.7345-2.1279l2.9784-2.733-4.1161-.56303c-.8318-.11378-1.5508-.60558-1.9228-1.31512zm.916-1.512c-.3747-.71472-1.4573-.71472-1.832 0l-2.29884 4.38474c-.1488.28382-.43642.48053-.76914.52605l-5.14027.70312c-.83788.11461-1.17244 1.08395-.56614 1.64025l3.71953 3.413c.24076.2209.35062.5392.29379.8512l-.87807 4.8193c-.14312.7855.73277 1.3846 1.48219 1.0137l4.59755-2.2754c.2976-.1472.6532-.1472.9508 0l4.5976 2.2754c.7494.3709 1.6253-.2282 1.4821-1.0137l-.878-4.8193c-.0569-.312.053-.6303.2938-.8512l3.7195-3.413c.6063-.5563.2717-1.52564-.5661-1.64025l-5.1403-.70312c-.3327-.04552-.6204-.24223-.7692-.52605z" fill="#fff" fillRule="evenodd" />
    </SVGWrapper>
  );
}

export { Star };
